/**
 * Markdown module is used to render Rich Text Editor as Markdown editor content
 *
 * @hidden
 * @deprecated
 */
export class MarkdownRender {
    /**
     * Constructor for content renderer module
     *
     * @param {IRichTextEditor} parent - specifies the parent.
     */
    constructor(parent) {
        this.parent = parent;
    }
    /**
     * The function is used to render Rich Text Editor content div
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    renderPanel() {
        const rteObj = this.parent;
        const div = this.parent.createElement('div', { id: this.parent.getID() + '_view', className: 'e-rte-content' });
        this.editableElement = this.parent.createElement('textarea', {
            className: 'e-content',
            id: this.parent.getID() + '_editable-content',
            attrs: {
                'aria-labelledby': this.parent.getID() + '_view',
                'aria-label': 'Markdown Editor',
                'lang': rteObj.locale.slice(0, 2),
                'dir': rteObj.enableRtl ? 'rtl' : 'ltr'
            }
        });
        div.appendChild(this.editableElement);
        this.setPanel(div);
        rteObj.rootContainer.appendChild(div);
    }
    /**
     * Get the content div element of RichTextEditor
     *
     * @returns {Element} - specifies the element
     * @hidden
     * @deprecated
     */
    getPanel() {
        return this.contentPanel;
    }
    /**
     * Get the editable element of RichTextEditor
     *
     * @returns {Element} - specifies the element
     * @hidden
     * @deprecated
     */
    getEditPanel() {
        return this.editableElement;
    }
    /**
     * Returns the text content as string.
     *
     * @returns {string} - specifies the string values.
     */
    getText() {
        return this.getEditPanel().value;
    }
    /**
     * Set the content div element of RichTextEditor
     *
     * @param  {Element} panel - specifies the element.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    setPanel(panel) {
        this.contentPanel = panel;
    }
    /**
     * Get the document of RichTextEditor
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getDocument() {
        return this.getEditPanel().ownerDocument;
    }
}
